import React, { useState } from 'react';
import { Send, Paperclip, Smile } from 'lucide-react';
import { Button } from './Button';
import { Textarea } from './Input';
import { chatStyles } from './utils';

const ChatInput = ({ 
  onSendMessage, 
  disabled = false, 
  placeholder = "Type your message...",
  maxLength = 1000
}) => {
  const [message, setMessage] = useState('');
  const [isComposing, setIsComposing] = useState(false);

  const handleSend = () => {
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !isComposing) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '16px',
    borderTop: `1px solid ${chatStyles.border}`,
    backgroundColor: chatStyles.background,
  };

  const inputContainerStyle = {
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-end',
  };

  const textareaWrapperStyle = {
    flex: 1,
    position: 'relative',
  };

  const actionsStyle = {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    paddingBottom: '8px',
  };

  const charCountStyle = {
    fontSize: '12px',
    color: chatStyles.mutedForeground,
    textAlign: 'right',
    marginTop: '4px',
  };

  return (
    <div style={containerStyle}>
      <div style={inputContainerStyle}>
        <div style={textareaWrapperStyle}>
          <Textarea
            value={message}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            onCompositionStart={() => setIsComposing(true)}
            onCompositionEnd={() => setIsComposing(false)}
            placeholder={placeholder}
            disabled={disabled}
            rows={1}
            style={{
              minHeight: '40px',
              maxHeight: '120px',
              resize: 'none',
              overflow: 'auto',
            }}
          />
          {maxLength && (
            <div style={charCountStyle}>
              {message.length}/{maxLength}
            </div>
          )}
        </div>
        
        <div style={actionsStyle}>
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => {/* Handle attachment */}}
            disabled={disabled}
          >
            <Paperclip size={16} />
          </Button>
          
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => {/* Handle emoji */}}
            disabled={disabled}
          >
            <Smile size={16} />
          </Button>
          
          <Button 
            onClick={handleSend}
            disabled={disabled || !message.trim() || message.length > maxLength}
            size="icon"
          >
            <Send size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export { ChatInput };